import { eventsList } from '../../events/list';
import { initHttp } from '../../utils/http';
import { extendDeep } from '../../utils/utils';
import { addEvents } from '../decorators';
import { defaultSettings } from '../private-site/settings';
import { sourceName } from './constants';
import { initItem } from './item';
import { initItems } from './items';
import { initSource } from './source';
export function Boards(userSettings) {
  if (userSettings === void 0) {
    userSettings = {};
  }
  this.siteMediaToken = userSettings.siteMediaToken;
  const requestOptions = {
    params: {
      site_token: userSettings.siteMediaToken
    }
  };
  const settings = extendDeep(defaultSettings, userSettings);
  const http = initHttp(requestOptions);
  const item = initItem(settings, http);
  const items = initItems(settings, http);
  const source = initSource(settings, http);
  this.name = sourceName;
  this.item = addEvents(this, eventsList.ITEM, item);
  this.items = addEvents(this, eventsList.ITEMS, items);
  this.source = addEvents(this, eventsList.SOURCE, source);
}